"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timer = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Timer = require("./Timer.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Timer = exports.Timer = function Timer(_ref) {
  var startedOn = _ref.startedOn;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    totalSeconds = _useState2[0],
    setSeconds = _useState2[1];
  var timeToNumber = new Date(startedOn).getTime();
  var setSecondsCallback = function setSecondsCallback() {
    var currentTime = new Date().getTime();
    var elapsedTime = parseInt((currentTime - timeToNumber) / 1000, 10);
    setSeconds(elapsedTime);
  };
  var forceTrailingZero = function forceTrailingZero(value) {
    if (value > 9) {
      return value;
    }
    return "0".concat(value);
  };
  (0, _react.useEffect)(function () {
    setInterval(function () {
      window.requestAnimationFrame(setSecondsCallback);
    }, 1000);
  }, []);
  var hours = forceTrailingZero(parseInt(totalSeconds / 3600, 10));
  var minutes = forceTrailingZero(parseInt((totalSeconds - hours * 3600) / 60, 10));
  var seconds = forceTrailingZero(totalSeconds - (hours * 3600 + minutes * 60));
  var showHours = parseInt(hours, 10) > 0;
  return _react["default"].createElement(_Timer.StyledSpan, null, "Live ", showHours ? "".concat(hours, ":") : '', minutes, ":", seconds);
};
Timer.propTypes = {
  startedOn: _propTypes["default"].string
};